<!--
 * @Author: 孙照
 * @LastEditTime: 2023-02-16 16:04:17
 * @Description: 充电过程数据弹框
 * @FilePath: \fuzhou\src\module\chargingProgressModal\index.vue
-->
<template>
  <div class="charging-progress-modal">
    <secondary-modal
      :visible="visible"
      @change-visible="handleChangeVisible">
      <template slot="content">
        <div class="charging-modal">
          <div class="charging-modal-title">
            充电过程数据
          </div>
          <div class="charging-modal-content">
            <voltage-line-chart  :voltageList="voltageList" :xData="xData"/>
            <electric-current-chart :currentLsit="currentLsit" :xData="xData" />
            <power-line-chart :powerLsit="powerLsit" :xData="xData" />
            <soc-line-chart :socLsit="socLsit" :xData="xData" />
          </div>
        </div>
      </template>
    </secondary-modal>
  </div>
</template>

<script>
// 二级弹框
import secondaryModal from '@/components/secondaryModal/index.vue';
// 电压折线图
import { getChargingProcessDetail } from '@/api/stationStatistics/index';
import voltageLineChart from './components/voltageLineChart.vue';
// 桩端电流折线图
import electricCurrentChart from './components/electricCurrentChart.vue';
// 桩端电量折线图
import powerLineChart from './components/powerLineChart.vue';
// soc 折线图
import socLineChart from './components/socLineChart.vue';

export default {
  name: 'chargingProgressModal',
  components: {
    secondaryModal,
    voltageLineChart,
    electricCurrentChart,
    powerLineChart,
    socLineChart,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    orderId: {
      type: String,
      default: '',
    },
  },
  watch: {
    orderId: {
      handler(val) {
        if (val) {
          this.getDetail();
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      voltageList: [],
      currentLsit: [],
      powerLsit: [],
      socLsit: [],
      xData: [],
    };
  },
  methods: {
    getDetail() {
      getChargingProcessDetail({
        orderId: this.orderId,
      }).then((res) => {
        if (res.code === '200') {
          // console.log('++++++++', res.data);
          if (!res.data.his || res.data.his.length === 0) {
            this.$message.warning('暂无数据');
            return;
          }
          res.data.his.forEach((item) => {
            this.xData.push(this.formatDuring(item.time));
            this.voltageList.push(item.voltage);
            this.currentLsit.push(item.current);
            this.powerLsit.push(item.power);
            this.socLsit.push(item.soc);
          });
        }
      });
    },
    formatDuring(mss) {
      // eslint-disable-next-line radix
      let hours = parseInt((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      // eslint-disable-next-line radix
      let minutes = parseInt((mss % (1000 * 60 * 60)) / (1000 * 60));
      // eslint-disable-next-line radix
      let seconds = parseInt((mss % (1000 * 60)) / 1000);
      hours = this.formatStringNumber(hours);
      minutes = this.formatStringNumber(minutes);
      seconds = this.formatStringNumber(seconds);
      return `${hours}:${minutes}:${seconds}`;
    },
    formatStringNumber(num) {
      return num < 10 ? `0${num}` : `${num}`;
    },
    handleChangeVisible(data) {
      this.$emit('change-visible', data);
    },
  },
};
</script>

<style lang="less" scoped>
.charging-progress-modal {
  .charging-modal {
    box-sizing: border-box;
    width: 100%;
    padding-top: 48px;
    padding-left: 70px;
    padding-right: 80px;
    .charging-modal-title {
      box-sizing: border-box;
      height:59px;
      line-height: 59px;
      padding-left: 54px;
      margin-bottom: 30px;
      .backgroundImage('@/assets/images/progressTitleBg.png');
      font-size: 24px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
    }
    .charging-modal-content {
      width: 100%;
      height: 100%;
      display: grid;
      grid-template-rows: repeat(2, 1fr);
      grid-template-columns: repeat(2, 1fr);
      gap: 0 50px;
    }

  }
}
</style>
